<template>
    <div class="echart-box">
        <v-chart :options="option" ref="my"  autoresize/>
    </div>
</template>
<script>
import ECharts from 'vue-echarts'

import 'echarts/lib/chart/pie'



import 'echarts/lib/component/title';
import 'echarts/lib/component/tooltip'


export default {
  name: 'pieChart_v2',
  props: {  
    title:String,
     data:Array,
     rd:{
       type:Array,
       default:()=>{
            return ['20%', '38%']
       }
     }
  },
  data () {  
    return {     
       option:{

       }    
    }
  },
  methods: {
 
  },
  mounted () {
    
    this.option = {
     
          title: {            
              text: this.title,
              textStyle:{
                color:'#4FAEFF',
                fontSize:14,
                fontWeight :"normal"
              },             
               x: 'center',//文字位置
                y:'8px'//文字位置
          },
          tooltip :{		
            trigger: "axis",
            axisPointer: {
              type: "none"        
            }
				  },    
        series: [
            {            
                type: 'pie',
                radius: this.rd,               
                minAngle: 5,           　　 //最小的扇区角度（0 ~ 360），用于防止某个值过小导致扇区太小影响交互
                avoidLabelOverlap: true,   //是否启用防止标签重叠策略
                labelLine:{  
                    normal:{                          

                    }
                },
                label: {
                      align:"center",                     
                      width:50,
                      rich:{},
                      formatter: (text) => {   
                        return text.name+"\n"+text.data.showvalue;
                      },
                      color: '#fff',  // 改变标示文字的颜色
                      fontSize:12    
                },
                emphasis: {                   
                   label:{
                     color:"#EACD2C"
                   }
                },                
                data: this.data                
            }
        ]
    };
      var len=this.data.length;
      var currentindex=0;
  
                   
         this.timer= setInterval(()=>{     
                       
                this.$nextTick(()=>{
                  
                    this.$refs.my.dispatchAction({
                        type: 'highlight',         
                        seriesIndex: 0,
                        dataIndex: currentindex                  
                    })
                  
                      this.$refs.my.dispatchAction({
                          type: 'downplay',
                          seriesIndex: 0,
                          dataIndex:currentindex==0? len-1:currentindex-1
                      });
                  
              
                     
                })
           
           
              currentindex==len-1? currentindex=0:currentindex++;
            },3000)      
  },
      beforeDestroy: function() {
            if (this.timer) {
                clearInterval(this.timer);
            }
        },
  components: {
      'v-chart': ECharts
  }  
}
</script>

